import React, { useCallback, useMemo } from 'react';

const { getLabel } = OptionUtils;
const regex = /<%=\s*(.*?)\s*%>/g;

/**
 * I18n component.
 * @type {<T extends keyof typeof import('../../../constants/i18n/zh_TW')>({ key1, key2, options }: { key1: T, key2: keyof typeof import('../../../constants/i18n/zh_TW')[T], options: any }) => React.ReactElement}
 */
const I18n = ({ key1, key2, options = {} }) => {
	// const compiler = split(str, regex);

	const split = useCallback((str, separator) => {
		let result = [];
		let startIndex = 0;
		let match;

		if (!(separator instanceof RegExp)) {
			separator = new RegExp(separator, 'g');
		}

		while ((match = separator.exec(str)) !== null) {
			result.push(str.slice(startIndex, match.index));
			if (options.hasOwnProperty(match[1])) {
				result.push(options[match[1]]);
			} else {
				// throw new Error('I18n options must have all replace key');
			}
			startIndex = separator.lastIndex;
		}

		result.push(str.slice(startIndex));
		return result;
	}, [options]);

	const compiler = useMemo(() => {
		const str = getLabel(key1, key2);
		return split(str, regex);
	}, [key1, key2, split]);

	return compiler.map((item, index) => {
		return (
			<React.Fragment key={index}>{item}</React.Fragment>
		);
	});
};

/**
 * I18n component with keys
 * @type {<T extends keyof typeof import('../../../constants/i18n/zh_TW')>(params: {
 * 	keys: [T, keyof typeof import('../../../constants/i18n/zh_TW')[T]],
 *  options: any
 * }) => React.ReactElement}
 */
// const I18nWithKeys = ({ keys, options = {} }) => {

// 	const str = getLabel(...keys);

// 	const compiler = split(str, regex);

// 	function split(str, separator) {
// 		let result = [];
// 		let startIndex = 0;
// 		let match;

// 		if (!(separator instanceof RegExp)) {
// 			  separator = new RegExp(separator, 'g');
// 		}

// 		while ((match = separator.exec(str)) !== null) {
// 			result.push(str.slice(startIndex, match.index));
// 			if (options[match[1]]) {
// 				result.push(options[match[1]]);
// 			} else {
// 				// throw new Error('I18n options must have all replace key');
// 			}
// 			startIndex = separator.lastIndex;
// 		}

// 		result.push(str.slice(startIndex));
// 		return result;
// 	}

// 	return compiler.map((item, index) => {
// 		return (
// 			<React.Fragment key={index}>{item}</React.Fragment>
// 		);
// 	});
// };

export {
	I18n,
	// I18nWithKeys
};
